import AdminLayout from "@/pages/admin/AdminLayout";
import AIAssistant from "@/pages/portal/AIAssistant";

// Admin variant of AI Assistant simply re-renders the portal AI inside admin layout for consistency.
// The AI has knowledge of all FLOWTALIS workflows; the same interface is shown for admins for now.

const AdminAI = () => {
  // Reuse component but wrap in admin layout would double the sidebar.
  // Instead we render a slimmer admin-oriented wrapper by delegating to the standalone route.
  return <AIAssistant />;
};

export default AdminAI;
